/**
 *  HomeServiceforBuyers
 */
import './styles.modules.scss';
import React from 'react';
import { Container } from 'reactstrap';
import { SERVICE_NAME } from '~constants/app';

function HomeServiceforBuyers() {
  return (
    <>
      <Container styleName="homeserviceforbuyers-container">
        <section className="pt-ll">
          <div className="wrapper" id="service">
            <h3 className="headline txt-en-s mb-ll ls-s mv">
              Service for Buyers
            </h3>

            {/* <div className="d-md-flex mb-4">
              <div className="w-100">
                <img src="/images/buyer/home/service01.webp" alt="" />
              </div>
              <div className="w-100 d-flex flex-column justify-content-center p-4">
                <h5 className="font-weight-bold">返品可能</h5>
                <p className="text-muted">
                  初めて購入するブランドの商品は返品が可能なため、
                  <br className="d-none d-md-inline" />
                  在庫を抱える不安がありません。
                  <br className="d-none d-md-inline" />
                  様々なブランドとの取り組みが可能となります。
                </p>
              </div>
            </div> */}

            <div className="d-md-flex mb-4">
              <div className="w-100">
                <img src="/images/buyer/home/service01.webp" alt="" />
              </div>
              <div className="w-100 d-flex flex-column justify-content-center p-4">
                <h5 className="font-weight-bold">60日サイトでの支払いが可能</h5>
                <p className="text-muted">
                  商品を店舗で売却後に仕入れの支払いが行えるように、
                  <br className="d-none d-md-inline" />
                  仕入れ費用は60日サイトでの支払いが可能です。
                </p>
              </div>
            </div>

            <div className="d-md-flex">
              <div className="w-100 d-md-none d-block">
                <img src="/images/buyer/home/service02.webp" alt="" />
              </div>
              <div className="w-100 d-flex flex-column justify-content-center p-4">
                <h5 className="font-weight-bold">ユニークなものが見つかる</h5>
                <p className="text-muted">
                  有名ブランドから{SERVICE_NAME}
                  でしか仕入れられないユニークなブランドまで、
                  <br className="d-none d-md-inline" />
                  品質の良い優良ブランドを厳選しております。
                </p>
              </div>
              <div className="w-100 d-none d-md-block">
                <img src="/images/buyer/home/service02.webp" alt="" />
              </div>
            </div>

            <div className="d-md-flex mb-4">
              <div className="w-100">
                <img src="/images/buyer/home/service03.webp" alt="" />
              </div>
              <div className="w-100 d-flex flex-column justify-content-center p-4">
                <h5 className="font-weight-bold">
                  短納期・小ロットでの仕入れが可能
                </h5>
                <p className="text-muted">
                  小ロットから即納可能なブランドも多く登録されております。
                  <br className="d-none d-md-inline" />
                  お店に必要なタイミングで必要な分だけ仕入れが可能です。
                </p>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </>
  );
}

export default HomeServiceforBuyers;
